export default {
  common: {
    language: 'Norsk',
    changeLanguage: 'Endre språk',
    currency: ',-',
    errors: {
      auth: {
        fetchToken: 'Kunne ikke hente token',
        retrieveToken: 'Kunne ikke hente tilgangstoken',
        missingCredentials: 'Bruker er ikke logget inn eller mangler nødvendige påloggingsdetaljer',
        loginRequired: 'Vennligst logg inn for å fortsette',
      },
    },
    session: {
      expired: 'Økt utløpt',
      expiredMessage: 'Din økt har utløpt. Vennligst last inn siden på nytt for å fortsette.',
    },
    actions: {
      add: 'Legg til',
      remove: 'Fjern',
      edit: 'Rediger',
      delete: 'Slett',
      save: 'Lagre',
      saveSelection: 'Lagre valg',
      cancel: 'Avbryt',
      close: 'Lukk',
      readMore: 'Les mer',
      showLess: 'Vis mindre',
      reload: 'Last inn på nytt',
      confirm: 'Bekreft',
      continue: 'Fortsett',
      confirmContinue: 'Velg og gå videre',
      back: 'Tilbake',
      or: 'Eller',
      navigate: {
        nextDay: 'Neste dag',
        previousDay: 'Forrige dag',
        home: 'Hjem',
      },
    },
    status: {
      loading: 'Laster...',
      error: 'Feil',
      success: 'Vellykket',
      empty: 'Ingen elementer tilgjengelig',
      noResults: 'Ingen resultater funnet',
    },
    passenger: {
      adult: 'Voksen',
      child: 'Barn',
      infant: 'Baby',
      student: 'Student',
      senior: 'Senior',
      companion: 'Ledsager',
      conscript: 'Vernepliktig',
      title: 'Passasjer',
      singlePassenger: '{count} {type}',
      multiplePassengers: '{count} passasjerer',
    },
    passengerCount: {
      adult: '{count} Voksen | {count} Voksne',
      child: '{count} Barn 0-5 år | {count} Barn 0-5 år',
      youth: '{count} Barn 6-17 år | {count} Barn 6-17 år',
      student: '{count} Student | {count} Studenter',
      senior: '{count} Honnør | {count} Honnør',
      conscript: '{count} Vernepliktig | {count} Vernepliktige',
      companion: '{count} Ledsager | {count} Ledsagere',
    },
  },
  header: {
    home: 'Hjem',
    myBookings: 'Mine Bestillinger',
    support: 'Kundestøtte',
    search: 'Søk reise',
    myPage: 'Min side',
    logout: 'Logg ut',
  },
  booking: {
    search: 'Søk',
    from: 'Fra',
    to: 'Til',
    date: 'Dato',
    passengers: 'Passasjerer',
    findTickets: 'Finn Billetter',
    selectReturn: 'Fortsett',
    bookingNumber: 'Bestillingsnummer',
    outbound: 'Utreise',
    inbound: 'Retur',
  },
  search: {
    title: 'Hvor vil du reise?',
    originLabel: 'Jeg vil reise fra holdeplass',
    destinationLabel: 'Jeg vil reise til holdeplass',
    originPlaceholder: 'Fra',
    destinationPlaceholder: 'Til',
    departureDate: 'Utreise',
    returnDate: 'Retur',
    continue: 'Fortsett',
    noResults: 'Ingen resultater funnet',
    loading: 'Laster...',
    switchDirection: 'Bytt retning',
    calendar: {
      selectDate: 'Velg dato',
      today: 'I dag',
      tomorrow: 'I morgen',
      nextWeek: 'Neste uke',
      custom: 'Egendefinert dato',
    },
  },
  afterSale: {
    afterSaleAvalibleMessage:
      'Ta kontakt med <a href="https://www.nor-way.no/kontakt-oss/kundeservice/" target="_blank" rel="noopener noreferrer">kundeservice</a> for informasjon om endring av reise.',
    cancellation: {
      title: 'Kansellering',
      confirmTitle: 'Bekreft avbestilling',
      close: 'Lukk',
      reviewChoices: 'Gjennomgå dine valg',
      directions: {
        outbound: 'Utreise',
        return: 'Retur',
      },
      refundAmount: 'Refusjonsbeløp',
      currency: 'NOK',
      refundText: 'Dette beløpet vil bli refundert til din betalingsmetode',
      cancel: 'Avbryt',
      confirm: 'Bekreft avbestilling',
      processing: 'Behandler...',
    },
    rebook: {
      title: 'Endre reise',
      backToTickets: 'Tilbake til mine billetter',
      loading: 'Laster...',
      changeEntireTrip: 'Endre hele reisen',
      continue: 'Fortsett med valgt reise',
      confirm: 'Bekreft',
      error: 'En feil oppstod',
      revertError: 'Kunne ikke tilbakestille endringene i bestillingen.',
      modalTitles: {
        outbound: 'Endre utreise',
        return: 'Endre returreise',
        entire: 'Endre hele reisen',
      },
      search: {
        title: 'Søk etter ny reise',
        continue: 'Fortsett med valgt reise',
        errors: {
          noAvailableJourneys: 'Ingen tilgjengelige reiser funnet',
          invalidSearch: 'Ugyldig søk',
          networkError: 'Nettverksfeil',
          general: 'En feil oppstod',
          noItemsSelected: 'Ingen billetter valgt',
          originStationNotSet: 'Avreisestasjon ikke valgt',
          destinationStationNotSet: 'Ankomststasjon ikke valgt',
          departureDateNotSet: 'Avreisedato ikke valgt',
        },
      },
    },
    addons: {
      addSeat: 'Legg til sete',
      selectAddons: 'Velg tillegg',
    },
    actions: {
      rebook: 'Endre reise',
      cancel: 'Kansellere reise',
      changeOwner: 'Endre reiseeier',
      viewReceipt: 'Vis kvittering',
    },
  },
  payment: {
    title: 'Betaling',
    contactInformation: 'Kontaktinformasjon',
    buyingForOthers: 'Jeg bestiller for noen andre',
    passengerContactInfo: 'Passasjer kontaktinformasjon',
    confirm: 'Bekreft',
    passengerHelpText: 'Vennligst fyll inn passasjerens kontaktinformasjon',
    methods: {
      card: 'Kort',
      title: 'Betalingsmetoder',
      payNow: 'Betal nå',
      specification: 'Betalingsspesifikasjon',
      total: 'Totalt',
      proceed: 'Gå til betaling',
      processing: 'Behandler betaling...',
      confirm: 'Bekreft betaling',
    },
    voucher: {
      title: 'Rabattkode',
      code: 'Rabattkode',
      add: 'Legg til rabattkode',
      remove: 'Fjern rabattkode',
    },
    refundInfo: {
      title: 'Refusjonsinformasjon',
      amount: 'Refusjonsbeløp: {amount} NOK',
      confirm: 'Be om refusjon',
    },
  },
  components: {
    backLink: 'Tilbake',
    error: {
      title: 'Feil',
      retry: 'Prøv igjen',
      close: 'Lukk',
    },
    form: {
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      email: 'E-post',
      phone: 'Telefon',
      address: 'Adresse',
      postalCode: 'Postnummer',
      city: 'Sted',
      required: 'Påkrevd felt',
      invalid: 'Ugyldig verdi',
    },
    button: {
      save: 'Lagre',
      cancel: 'Avbryt',
      close: 'Lukk',
      confirm: 'Bekreft',
      continue: 'Fortsett',
      back: 'Tilbake',
    },
    drawer: {
      close: 'Lukk',
    },
    breadcrumbs: {
      home: 'Hjem',
    },
    dropdown: {
      select: 'Velg',
      noResults: 'Ingen resultater funnet',
    },
    userInfo: {
      details: 'Detaljer',
      editProfile: 'Rediger profil',
      name: 'Navn',
      email: 'E-post',
      phone: 'Telefon',
      address: 'Adresse',
      password: 'Passord',
      save: 'Lagre',
      cancel: 'Avbryt',
      changePassword: 'Endre passord',
      updatePassword: 'Oppdater passord',
      logout: 'Logg ut',
      deleteAccount: 'Slett konto',
      deleteAccountConfirmation: 'Er du sikker på at du vil slette kontoen din?',
      deleteAccountWarning: 'Denne handlingen kan ikke angres.',
      currentPassword: 'Nåværende passord',
      newPassword: 'Nytt passord',
      confirmPassword: 'Bekreft nytt passord',
    },
  },
  travelPlanner: {
    search: {
      origin: 'Fra',
      destination: 'Til',
      switchDirection: 'Bytt retning',
      date: {
        departure: 'Avreise',
        return: 'Retur',
      },
    },
    hero: {
      planningLabel: 'Planlegg reisen',
      searchResultLabel: 'Tilgjengelige reiser',
      passengers: 'reisende',
      changeSearch: 'Endre søk',
      roundtrip: 'Tur/retur',
      oneWay: 'Enveis',
      passengerLabel: 'Velg passasjerer',
      searchReturn: 'Velg returreise og billett',
      searchOutbound: 'Velg avgang og billett',
      changeOutbound: 'Endre utreise',
      changeReturn: 'Endre returreise',
    },
    passenger: {
      title: 'Velg passasjerer',
      removePassenger: 'Fjern',
      addPassenger: 'Legg til',
      description: 'Passasjerer',
      travelCard: {
        placeholder: 'Velg reisekort',
        addTravelCard: 'Legg til reisekort',
      },
    },
    equimentPage: {
      equipmentHeader: 'Trenger du tillegg til reisen?',
      equipmentLabel: 'Velg tillegg',
      noProducts: 'Ingen produkter tilgjengelig',
    },
    guestUser: {
      continueAsGuest: 'Fortsett som gjest',
      noProfile: 'Ingen profil?',
      guestWarning:
        'Uten profil får du ikke en samlet oversikt over dine billetter og kvitteringer.',
    },
    myTravel: {
      outbound: 'utreise',
      inbound: 'retur',
      notSelected: {
        outbound: 'utreise ikke valgt',
        inbound: 'retur ikke valgt',
      },
      list: {
        seats: 'seter',
        currency: 'NOK',
        equipment: {
          count: '{count} {type}',
          description: '{type}',
        },
        total: 'Totalt å betale',
      },
    },
    journeyList: {
      details: {
        title: 'Reisedetaljer',
        stops: 'stopp',
        transfer: 'bytte',
        transfers: 'bytter',
        waitingTime: 'Bytte, {time} min',
        platform: 'Plattform',
        track: 'Spor',
      },
      travel: {
        'from': 'Fra',
        'to': 'Til',
        'departure': 'Avgang',
        'arrival': 'Ankomst',
        'duration': 'Reisetid',
        'price': 'Fra',
        'seats': 'Ledige plasser',
        'transfer': 'Bytte',
        'direct': 'Direkte',
        'full': 'Utsolgt',
        'few': 'Få plasser igjen',
        'platform': 'Plattform',
        'track': 'Spor',
        'Not open for sale': 'Ikke åpen for salg',
        'PRESALE_CLOSED': 'Nettsalg stengt',
      },
      tickets: {
        title: 'Velg billett',
        standard: 'Standard',
        flex: 'Fleksibel',
        description: 'Beskrivelse',
        conditions: 'Betingelser',
        select: 'Velg',
        selected: 'Valgt',
      },
    },
    seat: {
      title: 'Velg sete',
      description:
        'Velg setet du vil sitte på under reisen. Du kan også gå videre uten setevalg og få sete tildelt.',
      skipSelection: 'Forsett uten setevalg',
      showDetails: 'Reisedetaljer',
      seat: 'Sete',
      skipSeats: 'Fortsett uten seter',
      noSeatsSelected: 'No seats selected',
      selectSeats: 'Velg seter',
      selectedSeatsOutbound: 'Valgte seter for utreise:',
      selectedSeatsInbound: 'Valgte seter for returreise:',
      seatDescription: 'Setebeskrivelser',
      partialSeatModal: {
        title: 'Setevalg',
        description:
          'Du har kun valgt seter for én retning. Ønsker du å velge seter for den andre retningen også?',
      },
      firstFloor: 'Første etasje',
      secondFloor: 'Andre etasje',
      confirmationModal: {
        title: 'Bekreft setevalg for delstrekning',
        message:
          'Du har bare valgt seter for én strekning. Vil du fortsette uten å velge seter for den andre strekningen?',
      },
      transfer: {
        title: 'Sete valg',
        description: 'Select seats for each leg of your journey.',
        direction: '%{direction} Journey',
        segement: 'Strekning',
      },
      select: 'Velg seter',
      selectedSeat: 'Valgt sete',
      change: 'Endre seter',
      loading: 'laster...',
      noSeatReservation: 'Ikke mulig å reservere sete på strekningen',
      notAvailable: 'sete valg ikke tillgjenelig',
      properties: {
        STANDARD_SEAT: 'Standard sete',
        COMFORT_SEAT: 'Komfort sete',
        WINDOW: 'Vindu sete',
        AISLE: 'Gang sete',
        TABLE: 'Bord sete',
        POWER_OUTLET: 'Strømuttak',
        EXTRA_LEGROOM: 'Ekstra benplass',
        WHEELCHAIR: 'Rullestoltilpasset',
      },
      seatTypes: {
        vacantSeat: 'Ledig',
        unavailableSeat: 'Opptatt',
        comfortSeat: 'Komfortsete',
        panoramaSeat: 'Panoramasete',
        windowSeat: 'Vindussete',
        aisleSeat: 'Midtgangssete',
        frontSeat: 'Fremre sete',
        childSeat: 'Barnesete',
        standardSeat: 'Standardsete',
      },
    },
  },
  searchResult: {
    navigation: {
      back: 'Tilbake',
      continue: 'Fortsett',
      changeSearch: 'Endre søk',
      showDetails: 'Reisedetaljer',
      drawerTitel: 'Reisedetaljer',
    },
    noResults:
      'Ingen avganger er tilgjengelige på valgte dato. Bla til neste dag, eller rediger søket ditt.',
    noResultReturn:
      'Søket ditt gav ikke treff på valgte dag. Prøv på nytt med andre holdeplasser, eller annen dag',
    journey: {
      outbound: 'Utreise',
      return: 'Retur',
      noTravels: 'Ingen reiser tilgjengelig',
      from: 'Fra',
      to: 'Til',
      departure: 'Avgang',
      arrival: 'Ankomst',
      duration: 'Reisetid',
      price: 'Fra',
      seats: 'Ledige plasser',
      transfer: 'Bytte',
      direct: 'Direkte',
      full: 'Fullbooket',
      few: 'Få plasser igjen',
    },
  },
  myPage: {
    title: 'Min side',
    navigation: {
      bookings: 'Mine bestillinger',
      profile: 'Profil',
      settings: 'Innstillinger',
    },
    auth: {
      title: 'Logg inn på Min side',
      signupTitle: 'Opprett ny profil',
      login: 'Logg inn',
      email: 'E-post',
      password: 'Passord',
      confirmPassword: 'Bekreft passord',
      forgotPassword: 'Glemt passord?',
      submit: 'Opprett profil',
      register: 'Registrer deg',
      createAccount: 'Opprett profil',
      haveAccount: 'Har du allerede opprettet profil?',
      Otherkey: 'other string',
      errorGeneral: 'Feil brukernavnen eller passord',
      invalidCredentials: 'Ugyldig brukernavn eller passord',
      signup: {
        success: 'Konto opprettet',
        error: 'Konto opprettelse feilet',
        invalidEmail: 'Ugyldig e-postadresse',
        userNotFound: 'Bruker ikke funnet',
        sucessMessage: 'Sjekk din e-post for å aktivere konto',
      },
      passwordRequirements: {
        text: 'Passordet du velger må inneholde minst:',
        rule1: 'Minst 8 tegn totalt',
        rule2: 'Minst 1 stor bokstav, 1 liten bokstav',
        rule3: 'Minst 1 tall',
        rule4: 'Minst 1 spesialtegn (f.eks. ! eller #)',
      },
      resetPassword: {
        subTitle: 'Få nytt passord',
        title: 'Be om nytt passord',
        submit: 'Endre passord',
        success: 'Passord endret',
        placeholder: 'Skriv inn din e-post',
        error: 'Feil under endring av passord',
        errorMessage: 'Feil under endring av passord',
        successMessage:
          'Om det er registrert en konto på denne adressen, har vi sendt deg en e-post med lenke til å lage nytt passord',
        invalidEmail: 'Ugyldig e-postadresse',
        userNotFound: 'Fant ikke bruker',
      },
      confirmAccount: {
        title: 'Opprett passords',
        description: 'Vennligst sett ditt passord for å fullføre opprettelsen av kontoen.',
        password: 'Nytt passord',
        passwordPlaceholder: 'Skriv inn ditt nye passord',
        confirmPassword: 'Bekreft passord',
        confirmPasswordPlaceholder: 'Bekreft ditt nye passord',
        confirm: 'Sett passord',
        submit: 'Sett passord',
        success: 'Passordet er satt! Omdirigerer...',
        passwordRequirements:
          'Passordet må være minst 10 tegn og inneholde minst én stor bokstav, ett tall og ett symbol.',
        passwordsDoNotMatch: 'Passordene er ikke like',
        invalidConfirmationLink: 'Ugyldig bekreftelseslenke',
        errorMessage: 'Kunne ikke bekrefte konto',
      },
    },
    profile: {
      title: 'Min profil',
      personalInfo: 'Personlig informasjon',
      contactInfo: 'Kontaktinformasjon',
      changePassword: 'Endre passord',
      save: 'Lagre endringer',
      saved: 'Endringer lagret',
      error: 'Kunne ikke lagre endringer',
    },
    bookings: {
      title: 'Mine reiser',
      future: 'Fremtidige reiser',
      past: 'Tidligere reiser',
      loading: 'Laster reiser...',
      loadingMore: 'Laster flere reiser...',
      noFutureBookings: 'Du har ingen fremtidige reiser',
      noPastBookings: 'Du har ingen tidligere reiser',
      loadMore: 'Last flere reiser',
      error: 'Kunne ikke hente reiser. Vennligst prøv igjen senere.',
    },
    ticket: {
      yourTicet: 'Din billett',
      name: 'navn',
      bookingNumber: 'Bestillingsnummer',
      passengers: 'reisende',
      ticketTyp: 'Billettype',
      seat: 'Sete',
      equipment: 'Utstyr',
      discount: 'Rabatt',
      totalPrice: 'Pris',
      displayQr: 'Vis QR-kode',
    },
    aftersale: {
      rebook: {
        title: 'Endre reise',
      },
    },
    anonymousTicket: {
      title: 'Se min billett',
      email: 'E-post',
      emailPlaceholder: 'Skriv din e-postadresse',
      bookingNumber: 'Bestillingsnummer',
      bookingNumberPlaceholder: 'Skriv bestillingsnummer',
      continue: 'Hent min billett',
    },
  },
  confirmation: {
    title: 'Bestillingsbekreftelse',
    backToTickets: 'Til mine billetter',
    thankYou: 'Takk for din bestilling!',
    bookingNumber: 'Bestillingsnummer',
    receiptEmail: 'Kvittering vil bli sendt til din e-postadresse',
    downloadTicket: 'Last ned billett',
    viewBooking: 'Se bestilling',
  },
  descriptions: {
    tickets: {
      FLEX: {
        refundable: {
          text: 'Refunderbar frem til 15 min før avgang',
          value: 'true',
        },
        changeable: {
          text: 'Kan endres uten ekstra kostnad fram til 15 min før avgang',
          value: 'true',
        },
      },
      STANDARD: {
        refundable: {
          text: 'Ikke refunderbar',
          value: 'false',
        },
        changeable: {
          text: 'Kan endres for 39 kr fram til 1 time før avgang',
          value: 'true',
        },
      },
    },
    passengerTypes: {
      ADT: 'Fra 18 år',
      CHD: '0-5 år',
      YOU: '6-18 år',
      STU: 'Elev eller student, 18-30 år med gyldig skolebevis/studentbevis.',
      SEN: 'Fra fylte 67 år og personer med uførebevis fra NAV.',
      CON: 'Avtjener førstegangstjeneste og kan fremvise forsvarets ID-kort for vernepliktige eller innkallingsbrev til førstegangstjeneste.',
      COM: 'Person som ledsager en innehaver av kommunalt ledsagerbevis.',
    },
    passengerNames: {
      ADT: 'Voksen',
      CHD: 'Barn',
      INF: 'Baby',
      STU: 'Student',
      SEN: 'Senior',
      COM: 'Ledsager',
      CON: 'Vernepliktig',
    },
    equipmentTypes: {
      LUGGAGE: {
        displayName: 'Ekstra bagasje',
        description: 'Bestill ekstra bagasje utover de 2 kolli som er inkludert i billettpris.',
      },
      SPECIAL_LUGGAGE: {
        displayName: 'Spesialbagasje',
        description:
          'Bestill plass til pulk, surfebrett, golfbag eller annen bagasje som er utenfor vanlige mål.',
      },
      BIKE: {
        displayName: 'Sykkel',
        description: 'Bestill plass til sykkel. Maksimum 1 sykkel.',
      },
      SCOOTER: {
        displayName: 'Snøscooter',
        description:
          'Bestill videre frakt av personer og bagasje til hytte. Maksimum 1 snøscooter.',
      },
      PET: {
        displayName: 'Kjæledyr',
        description: 'Bestill plass til kjæledyr. Maksimum 1 kjæledyr.',
      },
    },
  },
}
